var myTransactions = function () {
    var resultsContainer = $('[data-id="transactions-results"]');
    var jQueryPagination = $('[data-id="jquery-transactions-pagination"]');
    var querystringPagination = $('[data-id="transactions-querystring-pagination"]');
    var moreResultsBtn = $('[data-id="transactions-load-more"]');
	var nextPageCounter = $('[data-id="transactions-next-page-counter"]');
	var urlNextPageAjax = $('[data-id="transactions-get-url"]');

	if (jQueryPagination.length) {
	    querystringPagination.hide();
	    jQueryPagination.show();
        
	    moreResultsBtn.on("click", function (evt) {
	        evt.preventDefault();

	        var url = urlNextPageAjax.val();
	        url += '&pg=' + nextPageCounter.val();

	        $.get(url, function (data) {
	            console.log(data.length);
	            if (data.length >= 10) {
	                resultsContainer.html(resultsContainer.html() + data);
	                nextPageCounter.val(parseInt(nextPageCounter.val()) + 1);

	                if (data.indexOf('<!-- last -->') != -1)
	                    jQueryPagination.hide();
                }
	            else {
	                jQueryPagination.hide();
	            }
	        });
	    });
	}
}